import { Users, Image as ImageIcon, CheckCircle2, Clock, Upload, RefreshCw, Loader2 } from 'lucide-react';
import { AutoProcessBadge } from './AutoProcessBadge';

const STATS = [
  { key: 'total_users', label: 'Registered attendees', icon: Users, tid: 'stat-total-users', tone: 'bg-cyan text-ink' },
  { key: 'total_images', label: 'Photos uploaded', icon: ImageIcon, tid: 'stat-total-images', tone: 'bg-white text-ink' },
  { key: 'processed_images', label: 'Processed', icon: CheckCircle2, tid: 'stat-processed-images', tone: 'bg-lime text-ink' },
  { key: 'pending_images', label: 'Pending', icon: Clock, tid: 'stat-pending-images', tone: 'bg-amber-400 text-ink' },
];

export const StatCards = ({ stats }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
    {STATS.map(({ key, label, icon: Icon, tid, tone }, i) => (
      <div key={key} className={`card card-hover p-5 fade-up fade-up-delay-${Math.min(i, 3)}`} data-testid={tid}>
        <div className="flex items-center justify-between mb-4">
          <p className="label">{label}</p>
          <span className={`w-8 h-8 flex items-center justify-center ${tone}`}><Icon className="w-4 h-4" /></span>
        </div>
        <p className="font-display font-bold text-4xl text-white tracking-tight">{stats ? stats[key] : '—'}</p>
      </div>
    ))}
  </div>
);

export const UploadPanel = ({ selectedFiles, onSelect, onUpload, onProcess, uploading, processing, pendingCount, onAutoProcessed }) => (
  <div className="card p-6" data-testid="upload-section">
    <div className="mb-5 flex flex-col sm:flex-row sm:items-start justify-between gap-3">
      <div>
        <h2 className="h-display text-lg">Upload event photos</h2>
        <p className="text-sm text-slate-400 mt-1">Photos from you and your photographers land here. Matching runs automatically 60s after the last upload — or press Match now.</p>
      </div>
      <AutoProcessBadge onCompleted={onAutoProcessed} />
    </div>
    <label
      htmlFor="file-input"
      className="flex flex-col items-center justify-center gap-2 border-2 border-dashed border-line p-10 bg-ink hover:border-cyan cursor-pointer transition-colors text-center"
    >
      <Upload className="w-6 h-6 text-cyan" />
      <p className="font-display font-bold uppercase tracking-wider text-sm text-white">
        {selectedFiles.length > 0 ? `${selectedFiles.length} file${selectedFiles.length > 1 ? 's' : ''} selected` : 'Click to choose photos'}
      </p>
      <p className="font-mono text-[11px] text-slate-500">JPG · PNG · multiple files supported</p>
      <input id="file-input" data-testid="file-input" type="file" multiple accept="image/*" onChange={onSelect} className="hidden" />
    </label>
    <div className="flex flex-col sm:flex-row gap-4 mt-6">
      <button data-testid="upload-btn" onClick={onUpload} disabled={uploading || selectedFiles.length === 0} className="btn-primary flex-1">
        {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
        {uploading ? 'Uploading…' : 'Upload photos'}
      </button>
      <button data-testid="process-btn" onClick={onProcess} disabled={processing || pendingCount === 0} className="btn-secondary flex-1">
        <RefreshCw className={`w-4 h-4 ${processing ? 'animate-spin' : ''}`} />
        {processing ? 'Matching faces…' : `Match now (${pendingCount || 0} pending)`}
      </button>
    </div>
  </div>
);
